
import debounce from 'lodash.debounce'
import Component, { mixins } from 'vue-class-component'
import BaseMapCanvas from '@/mixins/BaseMapCanvas'
import { Prop, Watch } from 'vue-property-decorator'
import Leaflet, { LatLng } from 'leaflet'
import axios, { AxiosResponse } from 'axios'
import Testable from '@/mixins/Testable'
import { MAPBOX_PARAMS } from '@/plugins/mapbox-config'

@Component
export default class CustomLocationMap extends mixins(BaseMapCanvas, Testable) {
	@Prop({ default: null })
	geoCoordinatesForMap!: LatLng | null

	@Prop({ default: null })
	city!: string | null

	@Prop({ default: null })
	country!: string | null

	layer!: Leaflet.LayerGroup
	minQueryLength: number = 3
	debounceInput: any

	marker: Leaflet.Marker | null = null

	mounted() {
		this.centerAtVesselLocation = false
		this.map.invalidateSize()
		this.layer = Leaflet.layerGroup().addTo(this.map)
		if (this.geoCoordinatesForMap) {
			this.addPin()
		}
	}

	created() {
		this.debounceInput = debounce(this.sendQuery, 500)
	}

	@Watch('geoCoordinatesForMap')
	addPin() {
		this.layer.clearLayers()

		const icon = Leaflet.icon({
			iconUrl: '/img/icons/markers/map-marker-alt-solid.svg',
			iconSize: [30, 30],
			iconAnchor: [15, 30],
			tooltipAnchor: [10, 0]
		})

		if (this.geoCoordinatesForMap) {
			this.map.setView([this.geoCoordinatesForMap.lat, this.geoCoordinatesForMap.lng], 10)
			this.marker = Leaflet.marker(this.geoCoordinatesForMap, {
				icon: icon
			}).addTo(this.layer)
		}
	}

	@Watch('city')
	@Watch('country')
	async moveCenter() {
		if (!this.marker && this.city && this.country && this.city.length >= this.minQueryLength) {
			this.debounceInput()
		}
	}

	async sendQuery() {
		const searchText = this.city + ', ' + this.country
		const response = (await axios.get(`https://api.mapbox.com/geocoding/v5/mapbox.places/${searchText}.json`, {
			params: { ...MAPBOX_PARAMS, limit: 3 }
		})) as AxiosResponse<any>

		if (response.data.features) {
			const coordinates = response.data.features[0].center
			this.map.setView([coordinates[1], coordinates[0]], 10)
		}
	}
}
